import React from "react";
import img from "../../img/banner2.gif";
const Banner = () => {
  return (
    <div>
      {/* <img className="h-[600px] w-full" src={img} alt="" /> */}
      <div class="  ">
        <div class="hero-content flex-col lg:flex-row-reverse">
          <img className="h-[380px] " src={img} alt="" />

          <div>
            <h1 class="text-5xl font-bold text-cyan-800">AirCool Shop</h1>
            <p class="py-6">
              AirCool offers Eco friendly split Air Conditioners that provides
              clean and healthy air for your family. Our Twinfold Inverter
              Technology saves up to 60% electricity. Control you AC from
              anywhere through IoT Smart Control by using Smart Phone. AirCool
              Twinfold Inverter AC has Horizontal & Vertical swing which enable
              the air to guide/swing in four directions. You will feel the same
              comfort at every corner of the room.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
